import { reactive } from 'vue'
import type { TaskBoard } from '@/types'

export interface TaskBoardsState {
  boards: TaskBoard[]
  selectedBoard: TaskBoard | null
  isLoading: boolean
  error: string | null
}

export const getInitialState = (): TaskBoardsState => ({
  boards: [],
  selectedBoard: null,
  isLoading: false,
  error: null,
})

export const createState = (): TaskBoardsState => {
  return reactive(getInitialState())
}

export const resetState = (state: TaskBoardsState): void => {
  const initial = getInitialState()
  state.boards = initial.boards
  state.selectedBoard = initial.selectedBoard
  state.isLoading = initial.isLoading
  state.error = initial.error
}
